/**
 * @desc orderFinish
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.AllocationUpdateOrderStatusDto, options?: any) {
  return updateResponse(
    http(URL + `/allocation/orderFinish`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
